<template>
	<div class="page_content explore_entity_inside career insights" aria-label="Career Insights Page">

		<div class="row page-heading">
    	<div class="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-7 input module_heading">
      	<span class="module_icon ico-career"></span>
    		<template v-if="career && career.name">
          <career-title :career="career"></career-title>
        </template>
  		</div>
      <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-5 px-0">
        <!--
        <b-dropdown :animation="animation" variant="link" no-caret class="create-section-menu">
          <template slot="button-content">
            <span class="icon-menu3x3"></span>
          </template>
        </b-dropdown>
        -->
        <div class="btn_container" v-if="showBackToResultButton">
          <b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
            <span class="btn_ic ic-back"></span>
            <span class="btn_txt"> {{ deCamelCase() }} </span>
          </b-btn>
        </div>
      </div>
    </div>

      	<div class="page_content_container">

			<career-navigation :active="'insights'" :code="code" :cipCode="cipCode" :returnTo="returnTo"></career-navigation>

			<div class="pg_content">
				<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">
					<div class="row pg_sec" style="padding-bottom: 0px; margin-bottom: 0px; width: 100%; margin-left: 2%;">

						<div class="col-12 explore-section">
        					<explore-insight-list :type="'insights'" :isAlumniInsights="'true'"></explore-insight-list>
						</div>

					</div> <!-- .pg_sec -->
				</div> <!-- .content_mid_panel -->
			</div> <!-- .pg_content -->

  		</div> <!-- .page_content_container -->

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CareerTitle from './CareerTitle'
import CareerNavigation from './CareerNavigation'
import ExploreInsightList from '../../explore/components/ExploreInsightList'

export default {
  name: 'careerInsights',
  props: ['code', 'cipCode', 'returnTo', 'showBackToResultButton'],
  components: {
    CareerTitle,
    CareerNavigation,
    ExploreInsightList
  },
  data: () => {
    return {
      career: {},
      DEFAULT_RETURN_TO: 'exploreCareerResults',
      EXPLORE_RESULTS: 'exploreCareerResults'
    }
  },

  mounted () {
    this.loadDataForCareerAlumniInsights()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadLogDashboardActivity',
      'setCurrentFacet',
      'loadCareer'
    ]),
    async loadDataForCareerAlumniInsights () {
      this.career = await this.loadCareer({ code: this.code, loadDataFromServer: true })
      this.loadLogDashboardActivity({action: 'viewCareerInsights', page: 'careerInsights', link: '', careerSocCode: this.code})
      this.setCurrentFacet('insights')
    },
    returnToClicked () {
      return this.$router.push({ name: this.returnTo })
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'return to career results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return result
    }
  },

  computed: {
    ...mapState({
    })
  },

  watch: {
  }
}
</script>
<style>
.jumbotron {
  background: #fffff;
}
.text-center {
  text-align: center;
}
.bg-gray{
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/app/career/components/CareerInsights.vue